<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
    name: "campus",
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "campusName",
            sortDesc: false,
            fields: [
                {
                    key: "campusName",
                    sortable: true,
                },
            ],
            form: {
                id: 0,
                campusName: "",
                shortName: "",
            },
            indexSelected: -1,
            tableBusy: false,
            fromSchool: window.IS_SCHOOL || false,
        };
    },
    computed: {
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.tableData.length;
        },
    },
    validations: {
        form: {
            campusName: { required },
            shortName: { required },
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onReset() {
            this.form = {
                id: 0,
                level: "",
                description: "",
            };
        },
        hideModal() {
            this.$bvModal.hide("campus-modal");
        },
        dropData(data) {
            this.$emit("dropData", data[0]);
            this.$bvModal.hide("campus-modal");
        },
        getData() {
            this.tableBusy = true;
            this.$store
                .dispatch("campus/GetCampus")
                .then((res) => {
                    this.tableBusy = false;
                    this.tableData = res.data;
                    let campusIds = this.$store.state.decrypt
                        .campusAccessList()
                        .map((item) => item.Id);
                    this.tableData = this.tableData.filter((item) => campusIds.includes(item.id));
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
    },
};
</script>

<template>
    <b-modal id="campus-modal"
             :title="`Campus List - ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"
             size="md"
             title-class="font-18"
             hide-footer
             no-close-on-backdrop>
        <div class="row mt-1">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter"
                     class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input autocomplete="off"
                                      v-model="filter"
                                      type="search"
                                      placeholder="Search..."
                                      class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                </div>
            </div>
        </div>
        <div class="table-responsive mb-0">
            <b-table class="datatables"
                     :items="tableData"
                     :fields="fields"
                     responsive="sm"
                     :per-page="perPage"
                     :current-page="currentPage"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     :filter="filter"
                     :filter-included-fields="filterOn"
                     :busy="tableBusy"
                     @filtered="onFiltered"
                     bordered
                     outlined
                     hover
                     striped
                     show-empty
                     select-mode="single"
                     selectable
                     @row-selected="dropData"
                     selected-variant="success">
                <template #empty="scope">
                    <div class="text-center">{{ scope.emptyText }}</div>
                </template>
                <template #table-busy>
                    <div class="d-flex justify-content-center align-items-center">
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell(campusName)="row">
                    {{ row.value }}
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage"
                                      :total-rows="rows"
                                      :per-page="perPage"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </b-modal>
</template>
